export const environment = process.env.REACT_APP_ENV;


export const variablesGlobales = {
    urlServiceBackend: environment === 'DEV' ? "https://dev.galilea.co:8443/backend/sandbox/" : environment === 'LOCAL' ? "http://localhost:4009" : "https://backend-lb.galilea.co",
    urlServiceWebsocket: environment === 'DEV' ? "wss://dev.galilea.co:8443/ws/" : environment === 'LOCAL' ? "http://localhost:4009" : "https://backend-lb.galilea.co/ws/",
    passBackoffice: "WantonioG@2022",
    test: "test",
    timemaxSignupForm: 5,
    typeUserVisitor: "visitor",
    typeUSerClient: "client",
    test2: "",
    urlServiceImports: environment === 'DEV' ? "https://dev.galilea.co:8443/backend/sandbox/" : environment === 'LOCAL' ? "http://localhost:4009" : "https://backend-lb.galilea.co/backend/imports",
    urlRedirectCobre: environment === 'PROD' ? "https://galilea.co/micredito" : environment === 'LOCAL' ? "http://localhost:3000/micredito" : "https://dev.galilea.co:8443/micredito",
    vapidKey: "BLstrXXUsakuvA9uqw4O9Dp2LAW72DjHWKRrz49VYAM4FK2tI3Hi9M4b72RKoGbe37O5ehUU88CTaDv041yt4m4",
    firmaElectronica: 145000,
    endpointApiChatAi: process.env.REACT_APP_ENV === 'PROD' ? process.env.REACT_APP_ENDPOINT_CHAT_IA_PROD : process.env.REACT_APP_ENV === 'DEV' ? process.env.REACT_APP_ENDPOINT_CHAT_IA_DEV :  process.env.REACT_APP_ENV === 'LOCAL' ? process.env.REACT_APP_ENDPOINT_CHAT_IA_LOCAL : "https://backend-lb.galilea.co/chatbot/api",
    usernameApiChatIa: process.env.REACT_APP_USERNAME_API_CHAT_IA_LOCAL || "",
    passwordApiChatIa: process.env.REACT_APP_PASSWORD_API_CHAT_IA_LOCAL || "",
}
